import type { SVGProps } from 'react';

/** Figma `home.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const HomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.8">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7086 15.4481L27.6667 14.6145V28.3339H29.3333C29.8856 28.3339 30.3333 28.7816 30.3333 29.3339C30.3333 29.8862 29.8856 30.3339 29.3333 30.3339H2.66666C2.11438 30.3339 1.66666 29.8862 1.66666 29.3339C1.66666 28.7816 2.11438 28.3339 2.66666 28.3339H4.33333V14.6145L3.29136 15.4481C2.8601 15.7931 2.2308 15.7232 1.88579 15.2919C1.54078 14.8606 1.61071 14.2314 2.04197 13.8863L12.8765 5.2187C14.7026 3.75783 17.2974 3.75783 19.1235 5.2187L29.958 13.8863C30.3893 14.2314 30.4592 14.8606 30.1142 15.2919C29.7692 15.7232 29.1399 15.7931 28.7086 15.4481ZM16 9.00055C13.975 9.00055 12.3333 10.6422 12.3333 12.6672C12.3333 14.6923 13.975 16.3339 16 16.3339C18.025 16.3339 19.6667 14.6923 19.6667 12.6672C19.6667 10.6422 18.025 9.00055 16 9.00055ZM18.3278 17.7494C17.7161 17.6671 16.9523 17.6672 16.0658 17.6672H15.9342C15.0477 17.6672 14.2839 17.6671 13.6722 17.7494C13.0167 17.8375 12.3883 18.0362 11.8787 18.5459C11.369 19.0556 11.1703 19.6839 11.0821 20.3394C10.9999 20.9511 10.9999 21.7149 11 22.6014L11 28.3339H13H19H21L21 22.6014L21 22.4366C20.9997 21.62 20.995 20.9128 20.9179 20.3394C20.8297 19.6839 20.631 19.0556 20.1213 18.5459C19.6117 18.0362 18.9833 17.8375 18.3278 17.7494Z"
        fill="#FF2D55"
      />
    </g>
    <g opacity="0.5">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3333 12.6667C14.3333 11.7462 15.0795 11 16 11C16.9205 11 17.6666 11.7462 17.6666 12.6667C17.6666 13.5871 16.9205 14.3333 16 14.3333C15.0795 14.3333 14.3333 13.5871 14.3333 12.6667Z"
        fill="#FF2D55"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3333 12.6667C14.3333 11.7462 15.0795 11 16 11C16.9205 11 17.6666 11.7462 17.6666 12.6667C17.6666 13.5871 16.9205 14.3333 16 14.3333C15.0795 14.3333 14.3333 13.5871 14.3333 12.6667Z"
        fill="#FF2D55"
      />
    </g>
    <path
      opacity="0.28"
      d="M16.0659 17.666C16.9524 17.666 17.7162 17.6659 18.3279 17.7482C18.9834 17.8363 19.6117 18.035 20.1214 18.5447C20.631 19.0544 20.8298 19.6827 20.9179 20.3382C20.995 20.9117 20.9998 21.6188 21.0001 22.4354L21.0001 28.3327H11.0001L11.0001 22.6002C11 21.7137 11 20.9499 11.0822 20.3382C11.1703 19.6827 11.3691 19.0544 11.8787 18.5447C12.3884 18.035 13.0168 17.8363 13.6723 17.7482C14.2839 17.6659 15.0478 17.666 15.9342 17.666H16.0659Z"
      fill="#FF2D55"
    />
    <path
      opacity="0.28"
      d="M21.3334 4H24.6667C25.0349 4 25.3334 4.29848 25.3334 4.66667L25.3334 10.1861L20.6667 6.45274V4.66667C20.6667 4.29848 20.9652 4 21.3334 4Z"
      fill="#FF2D55"
    />
  </svg>
);
